export const durationToString = (duration: number): string => {
  const hours = Math.floor(duration / 60);
  let leftMinutes = duration % 60;
  if(leftMinutes !== 0) {
    return `${hours}:${leftMinutes}hs` 
  } else {
    return hours + "hs";
  }
}